import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { captureRemixErrorBoundaryError } from '@sentry/remix';

import { type OddsGridIndexProps, OddsGridWithQuery } from '@cx-modules/odds-grid';

export const OddsGrid = (props: OddsGridIndexProps) => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary
      fallbackRender={({ error }) => {
        captureRemixErrorBoundaryError(error);
        return null;
      }}
    >
      <OddsGridWithQuery {...props} i18n={i18n} />
    </ErrorBoundary>
  );
};
